import './denied-page.scss';

import { useAuth } from '~modules/auth/model';
import { UserHelper } from '~modules/user/model';

export function DeniedPage() {
	const { user, logout } = useAuth();

	const handleLogout = () => {
		logout();
	};

	return (
		<div className="denied-page">
			<div className="container">
				<h2>
					{UserHelper.getName(user)}
					{user?.email && <> ({user.email})</>}, у вас недостаточно прав для получения данной
					функциональности.
					<br />
					Обратитесь в Сервис Деск компании
				</h2>
				<button className="btn btn--primery submit mt-2" onClick={handleLogout}>
					Выход
				</button>
			</div>
		</div>
	);
}
